export default function TracyTest() {
  return (
    <div style={{
      width: '100%',
      height: '800px',
      margin: '0 auto',
      position: 'relative',
      background: 'linear-gradient(180deg, #87CEEB 0%, #B8D4E8 100%)',
      overflow: 'hidden'
    }}>
      {/* Speech Bubble */}
      <div style={{
        position: 'absolute',
        top: '80px',
        left: '40px',
        width: '380px',
        background: '#FDF6E3',
        borderRadius: '20px',
        padding: '24px 28px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        zIndex: 20
      }}>
        <h3 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1a365d',
          margin: '0 0 16px 0',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          Hello, I'm ParkWise.
        </h3>
        <p style={{
          fontSize: '17px',
          color: '#2d3748',
          lineHeight: 1.5,
          margin: '0 0 16px 0',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          If you use a Blue Badge, Adult with Child, NHS, Military or other designated parking space, you can register here.
        </p>
        <div style={{
          width: '100%',
          height: '1px',
          background: '#e2e8f0',
          margin: '16px 0'
        }} />
        <p style={{
          fontSize: '17px',
          color: '#2d3748',
          lineHeight: 1.5,
          margin: 0,
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          You can also pay for parking or manage an existing registration.
        </p>
        
        {/* Speech bubble pointer */}
        <div style={{
          position: 'absolute',
          right: '-24px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 0,
          height: 0,
          borderTop: '20px solid transparent',
          borderBottom: '20px solid transparent',
          borderLeft: '28px solid #FDF6E3',
          filter: 'drop-shadow(4px 0 4px rgba(0,0,0,0.05))'
        }} />
      </div>

      {/* Tracy Character */}
      <img 
        src="/parkwise-assistant.png" 
        alt="Tracy - ParkWise Assistant"
        style={{
          position: 'absolute',
          right: '-40px',
          top: '0',
          height: '780px',
          objectFit: 'contain',
          objectPosition: 'right bottom',
          zIndex: 10
        }}
      />
    </div>
  );
}
